import axios from "axios";

import {
    doLogoutSuccess,
    setAccessDenied,
    doGetLoggedInUserDetails,
} from "src/reducers/reducer_core";

// eslint-disable-next-line import/no-anonymous-default-export
export default (store) => {
    axios.interceptors.request.use(async (request) => {
        request.withCredentials = true
        return request
    })

    axios.interceptors.response.use(
        function (response) {
            return response
        },
        function (error) {
            if (error.response) {
                if (error?.response?.status === 401) {
                    store.dispatch(doLogoutSuccess())
                    window.location.href = window.location.pathname + window.location.search + '#/login'
                }

                if (error?.response?.status === 403) {
                    // The server refused something the UI believed was allowed,
                    // which means our permission snapshot is stale. Surface it --
                    // there is no toast system mounted, so DefaultLayout renders a
                    // dialog off this flag -- and re-read /admin/auth/me so the
                    // sidebar and routes correct themselves behind the dialog.
                    store.dispatch(setAccessDenied(
                        error?.response?.data?.errorMessage || "You do not have permission to do that."
                    ))
                    store.dispatch(doGetLoggedInUserDetails())
                }
            }

            return Promise.reject(error)
        },
    )
}
